import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import FirstClientUploadStep from './FirstClientUploadStep'
import FirstClientUploadSubmitStep from './FirstClientUploadSubmitStep'
import { uploadFileKindOptions } from '../constants'
import { map } from 'lodash'
import { useNotifications, useFileUpload, useAuth, useAnalytics } from 'hooks'
import useReportCreate from '../hooks/useReportCreate'
import useReportAddFile from '../hooks/useReportAddFile'
import useReportRun from '../hooks/useReportRun'

export default function FirstClientUploadReport({
  step,
  submitting,
  setSubmitting,
  onNext,
  onBack,
  onClose,
}) {
  const [uploadSource, setUploadSource] = useState('qbo')
  const { currentCompany } = useAuth()
  const [files, setFiles] = useState([])
  const [fileKinds, setFileKinds] = useState({})
  const [reportName, setReportName] = useState('')
  const notifications = useNotifications()
  const [createReport] = useReportCreate()
  const [addReportFile] = useReportAddFile()
  const [runReport] = useReportRun()
  const [uploadFiles, { progress }] = useFileUpload()
  const analytics = useAnalytics()
  const history = useHistory()

  const sourceFileKindOptions = uploadFileKindOptions[uploadSource]
  const canContinue = Object.keys(fileKinds).length === sourceFileKindOptions.length

  const handleCreate = async () => {
    setSubmitting(true)

    const { report } = await createReport({
      companyId: currentCompany.id,
      kind: 'anomaly:1',
      name: reportName,
    })

    // build file descriptors
    const descriptors = map(fileKinds, (file, kind) => ({ kind, file }))

    // upload files
    const uploadResults = await uploadFiles(`reports/${report.rowId}/source`, descriptors)

    // create report inputs
    for (let i = 0; i < uploadResults.length; i++) {
      await addReportFile({
        type: 'SOURCE',
        reportId: report.rowId,
        userFileId: uploadResults[i].id,
      })
    }

    // call the runReport lambda, but don't wait for it since
    // we'll get updates via report subscription
    runReport({ reportId: report.id })

    analytics.track('Report Created', { reportId: report.rowId })
    analytics.track('First Client Flow Completed', {
      companyId: currentCompany.id,
      reportId: report.rowId,
    })

    notifications.info('Report created.')

    onClose()

    history.push(`companies/${currentCompany.id}/reports`)
  }

  if (step === 1) {
    return (
      <FirstClientUploadStep
        onChange={setUploadSource}
        submitting={submitting}
        files={files}
        setFiles={setFiles}
        uploadSource={uploadSource}
        fileKinds={fileKinds}
        setFileKinds={setFileKinds}
        sourceFileKindOptions={sourceFileKindOptions}
        canContinue={canContinue}
        onNext={onNext}
        onBack={onBack}
        onClose={onClose}
      />
    )
  }

  return (
    <FirstClientUploadSubmitStep
      onBack={onBack}
      onDone={handleCreate}
      submitting={submitting}
      progress={progress}
      reportName={reportName}
      setReportName={setReportName}
      onClose={onClose}
    />
  )
}
